
class GenericModalComponent {
    constructor(element) {
        this.element = element;
        this.closeButton = this.element.querySelector('.generic-modal__close a');
        this.addCloseListener();
    }

    openModal() {
        this.element.classList.add('show');
        setTimeout(() => this.element.classList.add('pop'), 100);
    }

    addCloseListener() {
        this.closeButton?.addEventListener('click', () => this.closeModal());
    }

    closeModal() {
        this.element.classList.remove('pop');
        setTimeout(() => this.element.classList.remove('show'), 300);
    }
}

export default GenericModalComponent;
